import { QueryClient, QueryClientProvider } from "react-query";
import type { PaymentProcessor } from "@/react/types/CurrentCommunity";
import { ModalManagerProvider } from "@circle-react/components/Layout/ModalManagerProvider";
import { SpaceGroupsContextProvider } from "@circle-react/contexts/spaceGroupsContext";
import { SpacesContextProvider } from "@circle-react/contexts/spacesContext";
import { reactQueryConfig } from "@circle-react/providers/QueryClient/reactQueryConfig";
import { ToastProvider } from "@circle-react-uikit/ToastV2";
import { PaywallsComponent } from "./PaywallsComponent";

const queryClient = new QueryClient(reactQueryConfig);

interface PaywallsAdminProps {
  paymentProcessor: PaymentProcessor;
}

export const PaywallsAdmin = ({ paymentProcessor }: PaywallsAdminProps) => (
  <SpaceGroupsContextProvider>
    <SpacesContextProvider>
      <ToastProvider>
        <QueryClientProvider client={queryClient}>
          <ModalManagerProvider>
            <PaywallsComponent paymentProcessor={paymentProcessor} />
          </ModalManagerProvider>
        </QueryClientProvider>
      </ToastProvider>
    </SpacesContextProvider>
  </SpaceGroupsContextProvider>
);
